<template>
	<li @click="loadForm">
		<a>
			<i v-if="!is_load" class="fa fa-cogs"></i>
			<i v-else class="fa fa-spin fa-spinner"></i>
			{{ get_name_form(form) }}
		</a>
	</li>
</template>
<script>
	export default {
		inject: ['assets'],
		props: ['selfRefs', 'form'],
		data() {
			return {
				is_load: false,
			};
		},
		methods: {
			loadForm() {
				if (!this.is_load) {
					this.is_load = true;
					this.selfRefs.SmartForms.open(this.form).then((resp) => {
						this.is_load = false;
					});
				}
			},
			get_name_form(id) {
				if (this.assets.sForms == null)
					return 'Carregando os dados do form';
				let index = this.assets.sForms.findIndex(
					(item) => item.cod == id
				);
				if (index == -1) return 'Form não identificado';
				else return this.assets.sForms[index].titulo;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/btnLoadSmartForm.vue